// System config routes
export default [
  {
    path: 'system-config',
    name: 'systemConfig',
    component: () =>
      import(
        /* webpackChunkName: "systemConfig" */ '../views/systemConfig/SystemConfig.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: [],
      routePermissions: ['systemAdministration'],
    },
  },
];
